<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div class="animated fadeIn">
    <template v-if="base">
      <List v-show="list" ref="list" />
    </template>
    <Detail v-if="detail" @refresh="refresh" />
  </div>
</template>

<script>
import moment from 'moment-timezone';
import { api } from '@/f1/service';

import List from './QNA.List.i18n';
import Detail from './QNA.Detail.i18n';

export default {
  components: { List, Detail },
  data: () => ({ base: false, list: false, detail: false }),
  methods: {
    refresh() { this.$refs.list.$children && this.$refs.list.$children.forEach(x => x.refresh()) },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = false); }
      else { this.detail = !(this.list = false); }
    }
  },
  watch: {
    '$route' (to, from) {
      console.log('[vue] qna', 'route changed', to.param);
      this.select(to.params);
    }
  },
  created() { console.log('[vue] qna', 'created'); },
  destroyed() { console.log('[vue] qna', 'destroyed'); },
  mounted() { console.log('[vue] qna', 'mounted'); this.select(this.$route.params); },
}
</script>
